<template>
  <section class="shop-management orderHistory">
    <div class="orderHistory verified-detail" v-if="shopManageData && shopManageData.documentStatus !='NOT_ADDED'">
      <div class="flx" style="padding: 0 15px;">
      <div class="shopqr-detail" v-if="shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO" @click="getQRCode('my_qrcode')">
            <div class="shop-image">
            <img :src="shopQrDetail[0].sellerLiteDTO.shopImage" />
            </div>
            <div class="shop-detail" style="    z-index: 1;">
              <p class="shop-name">{{shopQrDetail[0].sellerLiteDTO.storeName}}</p>
              <p class="address"> <span class="material-icons" style="font-size: 1.25em">location_on</span> {{
          shopQrDetail[0].sellerLiteDTO.sellerShopAddress.address
        }}</p>
        
            </div>

          </div>
          <span class="form-status" v-if="shopManageData">
            <span style="background:#C81000" class="status-text" v-if="shopManageData.documentStatus === 'REJECTED'">Rejected</span>
            <span style="background:#DA7C00" class="status-text" v-if="shopManageData.documentStatus === 'UNVERIFIED'">Pending</span>
            <span style="background:#138808" class="status-text flx" v-if="shopManageData.documentStatus === 'VERIFIED'"> <span class="material-icons" style="font-size: 17px;">
check_circle_outline
</span>&nbsp;Verified</span>
            <span style="display:block" class="info-text"  v-if="shopManageData.documentStatus">Status</span>
          </span>

      </div>
      <div class="field-row" style="padding: 8px 15px;">
            <div class="flx">
                <p class="radio-option" :class="{'active': selectedPincodeOption === 'ALL_INDIA'}" @click="getSelectedPincodeOption('ALL_INDIA')">
                        <span class="select-radio"></span>&nbsp; {{$t('allIndia')}}
                </p>
                <p class="radio-option" :class="{'active': selectedPincodeOption === 'ADD_PINCODE'}"  @click="getSelectedPincodeOption('ADD_PINCODE')">
                        <span class="select-radio"></span>&nbsp; {{$t('addPincode')}}
                </p>
                <p class="radio-option" :class="{'active': selectedPincodeOption === 'CITY_PINCODE'}"  @click="getSelectedPincodeOption('CITY_PINCODE')">
                        <span class="select-radio"></span>&nbsp; {{$t('inCity')}}
                </p>
            </div>
            
            <div v-if="selectedPincodeOption==='ADD_PINCODE'">            
              
              <input
                name="supportedPincodeList"
                type="number"
                id="text_val"
                :placeholder="$t('whereDoYouWantToShowShop') "
                @input="getSupportedPin"
                class="input-style"
                style="width: 100%; margin: 8px 0;"
              />
              <span class="error-msg" v-if="errorMsg">ऐड कहाँ दिखाना चाहते हैं ?</span>
              <ul v-if="supportedPincodeList.length" class="chiplisting" style="max-height: 148px;overflow: scroll;padding-left: 4px;padding-bottom: 4px;margin-top: 4px;border: 1px solid #ccc;border-radius: 5px;">
                <li
                  v-for="(pincode, index) in supportedPincodeList"
                  :key="index"
                >
                  <span class="text-label">{{ pincode }}</Span>
                  <span class="remove-pin" @click="removePincode(index)">
                    <close-icon />
                  </Span>
                </li>
              </ul>
          </div>
            <div v-if="selectedPincodeOption==='CITY_PINCODE'">  
                
                <div style="position:relative" class="city-action">
                <div class="flx search_bar">
                <i class="material-icons">search</i>
                <input
                  name="supportedPincodeList"
                  type="text"
                  id="city_val"
                  :placeholder="$t('searchYourCity') "
                  v-on:keyup="getSearchCity($event)"
                  v-model="selectedCityOption"
                  class="input-style"
                />
                
                </div>
                <span class="error-msg" v-if="errorMsg">ऐड कहाँ दिखाना चाहते हैं ?</span>
                <div style="position:absolute; right:8px;height: 35px;color:#999;display:flex;align-items:center;top:0">
                <i class="material-icons" @click="isFillTitle('cityInput')" v-if="$cookie.get('version-code') > 11">mic</i>
                <span class="close-icon" v-if="searchedCityList.length && selectedCityOption" @click="closedSearchedCity()">x</span>
                </div>
                <!-- <span class="close-icon" v-if="searchedCityList.length && selectedCityOption" @click="closedSearchedCity()">x</span> -->
                  <div class="city_list" v-if="searchedCityList.length && selectedCityOption">
                  <h5>{{$t('selectCity')}}</h5>
                  <!-- v-if="!existPincodeCity.includes(item.block)" -->
                  <ul >
                    <li v-for="(item, index) in searchedCityList"                    
                      :key="index">
                      <div class="city-row"  @click="existPincodeCity.hasOwnProperty(item.block)?unSelectSearchedCity(item.block, item.state) : selectSearchedCity(item.block, item.state)"><span class="city_name"
                      :class="{active:existPincodeCity.hasOwnProperty(item.block)}">{{ item.block }} , {{item.state}}</span> <span class="material-icons">{{existPincodeCity.hasOwnProperty(item.block)? 'check_box': 'check_box_outline_blank'}}</span></div>
                      </li>
                  </ul>
                  </div>
                </div>
                <ul v-if="supportedPincodeList.length" class="chiplisting">    
                  <li
                    v-for="(pincode, index) in supportedPincodeList"
                    :key="index" style="border:0;padding: 0;display:block;margin:0;height:0">
                    <span class="text-label" style="font-size:0">{{ pincode }}</Span>
                  </li>
                </ul>         
                <ul v-if="Object.keys(existPincodeCity).length" class="chiplisting" style="max-height: 148px;overflow: scroll;padding-left: 4px;padding-bottom: 4px;margin-top: 4px;border: 1px solid #ccc;border-radius: 5px;">
                <span v-for="(value, key) in existPincodeCity"
                :key="key"> 
                <li v-for="(chip,index) in value" :key="index" >
                    <span >
                      <span class="text-label">{{ chip }}</span>
                    <span class="remove-pin" @click="removeCityPincode(key, index)">
                      <close-icon />
                    </span>
                    </span>
                    
                  
                  </li>
                </span>
                  
                </ul>
            </div>
          </div>
      <div v-if="shopManageData.shopDocumentDTO">
      <p class="verified-reason" v-if="shopManageData.documentStatus === 'VERIFIED' && shopManageData.shopDocumentDTO.comments"> {{shopManageData.shopDocumentDTO.comments}}</p>
      <p class="reject-reason" v-if="shopManageData.documentStatus === 'REJECTED' && shopManageData.shopDocumentDTO.comments"><strong>{{$t('reason')}}:</strong> {{shopManageData.shopDocumentDTO.comments}}</p>
      <div class="transfer-bank-account" v-if="shopManageData.shopDocumentDTO">
        <h3>{{$t('selefieAndVideo')}}</h3>
        <div class="flx">
        <ul class="doc-list flx" @click="isVerificationFormPopup = !isVerificationFormPopup">
          <li class="shop-video">
            <video :src="shopManageData.shopDocumentDTO.shopVideoUrl"></video>            
            <span class="default-icon"><i class="material-icons">play_arrow</i></span>
          </li>
          <li class="shop-photo">
            <img :src="shopManageData.shopDocumentDTO.selfieUrl" />
            <span class="default-icon"><i class="material-icons">insert_photo</i></span>
          </li>
        </ul>
        <span class="view-doc" @click="isVerificationFormPopup = !isVerificationFormPopup">{{$t('viewAllDocuments')}}</span>
        </div>
      </div>
      </div>
    </div>
    <div class="available-payment-option">
      <p style="font-size: 0.938em;color: #505050; padding-bottom: 8px;">Available Payment Options</p>
      <ul class="avilability-option">              
        <li class="list-item" @click="(shopManageData.codEnable = !shopManageData.codEnable)"><span class="item" :class="{'active':shopManageData.codEnable}"></span> COD</li>
        <li class="list-item" @click="(shopManageData.onlineEnable = !shopManageData.onlineEnable)"><span class="item" :class="{'active':shopManageData.onlineEnable }"></span> Online Payment</li>
        <li class="list-item" @click="(whatsAppEnable = !whatsAppEnable)"><span class="item" :class="{'active':whatsAppEnable }"></span> Buy on WhatsApp</li>
      </ul>
      <div class="whatsapp-input" v-if="whatsAppEnable">
        <p>Enter WhatApp Number</p>
        <input type="number" placeholder="Enter Number" v-model="shopManageData.whatsAppNumber"/>
      </div>
    </div>
    <div class="transfer-bank-account">
      <h3>डिस्काउंट परसेंटेज</h3>
      <ul class="list-item">
        <li>
          <div class="flx">
            <span
            class="custom-radio active"
          ></span>
            <p class="width70">अपनी दूकान पर डिस्कॉउंट दें </p>
            <input
              type="number"
              min="1"
              max="1000"
              placeholder="₹ 1000"
              v-model="shopManageData.discountPercentage"
            /> %
          </div>
            
        </li>
      </ul>
    </div>
    <div class="transfer-bank-account">
      <h3>{{$t('transferBankAccount')}}</h3>
      <ul class="list-item">
        <li @click="changeStatus(true)">
          <span
            class="custom-radio"
            :class="{ active: isBankAccount === true }"
          ></span>
          <p>{{$t('transferInstantlyToBankAccount')}}</p>
        </li>
        <li @click="changeStatus(false)">
          <div>
            <span
              class="custom-radio"
              :class="{ active: isBankAccount  === false }"
            ></span>
            <!-- <p v-if="shopManageData.transferAfterAccumulateAmount">Transfer after <strong>₹{{shopManageData.transferAfterAccumulateAmount}}</strong> accumulated</p> -->
            <p v-if="shopManageData.transferAfterAccumulateAmount" v-html="$t('transferAfterAccumulated',{transferAfterAccumulateAmount:shopManageData.transferAfterAccumulateAmount})"
          ></p>
            <p v-else v-html="$t('transferAfterAccumulated',{transferAfterAccumulateAmount:100})"></p>
            <p class="padding-top" v-if="shopManageData.totalAccumulateAmount">{{$t('accumulatedAmount')}}:<span>₹{{shopManageData.totalAccumulateAmount}}</span></p>
          </div>
        </li>
      </ul>
    </div>
    <div class="transfer-bank-account homedelivery">
      <h3>{{$t('homeDelivery')}}</h3>
      <ul class="list-item">
        <li @click="changeDeliveryStatus('FREEDELIVERY',true)">
          <span
            class="custom-radio"
            :class="{ active: homeDeliveryAction === 'FREEDELIVERY' }"
          ></span>
          <p>{{$t('freeHomeDelivery')}}</p>
        </li>
        <li @click="changeDeliveryStatus('DELIVERYMINORDER', true)"  v-if="!$route.query.CLOUDSHOP">
          <div class="flx">
            <span
              class="custom-radio"
              :class="{ active: homeDeliveryAction === 'DELIVERYMINORDER' }"
            ></span>
            <p class="width70">{{$t('freeHomeDeliveryWithMinimumOrderAmount')}}</p>
            <input
              type="number"
              min="0"
              max="1000"
              placeholder="₹ 1000"
              v-model="shopManageData.minimumOrderAmount"
            />
          </div>
        </li>
        <li @click="changeDeliveryStatus('DELIVERY100MAX', true)" v-if="!$route.query.CLOUDSHOP">
          <div class="flx">
            <span
              class="custom-radio"
              :class="{ active: homeDeliveryAction === 'DELIVERY100MAX' }"
            ></span>
            <p
            class="width70"
            v-html="$t('homeDeliveryCharge',{deliveryCharge:100})"
          ></p>
            <input
              type="number"
              name="quantity"
              :min="shopManageData.minimumDeliveryCharges"
              :max="shopManageData.maximumDeliveryCharges"
              placeholder="₹ 10"
              v-model="shopManageData.deliveryCharges"
            />
          </div>
        </li>
        <li @click="changeDeliveryStatus('DELIVERYOFF', false)"  v-if="!$route.query.CLOUDSHOP">
          <div class="flx">
            <span
              class="custom-radio"
              :class="{ active: homeDeliveryAction === 'DELIVERYOFF' }"
            ></span>
            <p class="width70">{{$t('deliveryOff')}}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="full-btn">
    <div class="submit-button" @click="validateFields()" v-if="$route.query.shopid">{{$t('update')}}</div>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
    <div class="verification-form-wrapper">
    <VerificationForm v-if="isVerificationFormPopup" :getShopQrDetail='shopQrDetail' @closeVerificationForm='isVerificationFormPopup=!isVerificationFormPopup' />
    </div>
  </section>
</template>
<script>
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import CustomToaster from "../components/Common/CustomToaster";
import '../assets/css/order-history.scss';
import VerificationForm from '../components/ShopManagementSection/VerificationForm'
import CloseIcon from '@/components/Icons/CloseIcon.vue';
export default {
  name: "ShopManageMent",
  components: {CustomToaster,VerificationForm,CloseIcon},
  data() {
    return {
      isBankAccount: null,
      homeDeliveryAction: '',
      isValidDetail: false,
      toasterData: {},
      loading: false,
      shopManageData: {
        minimumOrderAmount: '100',
        deliveryCharges: '10',
        discountPercentage: 1,
        pincodes: [],
        codEnable: false,
        onlineEnable:true,
        whatsAppNumber:null
      },
      whatsAppEnable:false,
      shopQrDetail: [],
      getShopDocument: {},
      isVerificationFormPopup:false,
      searchedCityList: [],
      selectedCityOption: '',
      existPincodeCity:{},
      selectedPincodeOption:'',
      supportedPincodeList:[],
      errorMsg: false
    };
  },

  methods: {
    selectedCity(cityName){
      this.shopManageData.city = cityName
      this.isSelectCity = !this.isSelectCity
    },
    closedSearchedCity(){
      this.searchedCityList = [];
      this.selectedCityOption = ''
    },    
    getSupportedPin(_event){
      if(_event.target.value.length == 6){   
        if (this.supportedPincodeList.includes(_event.target.value)) {
          _event.target.value = "";
          this.toasterData = {
                  msg: 'Pincode already in used',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isValidDetail = true;
              return
        }      
         this.supportedPincodeList.push(_event.target.value.trim());
         if(this.selectedPincodeOption ==='ADD_PINCODE'){
           this.waitingIcon= true
          ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${this.supportedPincodeList.toString()}`, "get").then((response) => {
            this.waitingIcon= false
              this.totalUserCount =(response.data.data.userCount)
          }).catch( err=>{
            this.waitingIcon = false
          })
         }
         _event.target.value = "";
      }
    },
    getSearchCityViaMic(res){
        this.selectedCityOption =res.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
        this.getListOfCity(this.selectedCityOption)
    },
    getSearchCity(_event){
      
      if(_event.target.value.length > 2){
        if (
          _event != null &&
          typeof _event.keyCode != "undefined" &&
          _event.keyCode == 13
        ){
          this.selectedCityOption = _event.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
          this.getListOfCity(this.selectedCityOption)
        }else {
          this.selectedCityOption = _event.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
          this.getListOfCity(this.selectedCityOption)
        }
        
        
      }
    },
    getListOfCity(cityOption){
      this.waitingIcon = true
      const obj ={
          query: cityOption,
          pageIndex: 0,
          limit: 10,
          highlight: true
        }
       ApiCaller('https://localsearch.mall91.com/search/',`suggestions/cities`, "post",obj).then((response) => {
         this.waitingIcon = false
        this.searchedCityList = response.data.pincodes;
        if(response.data.pincodes && response.data.pincodes.length && response.data.pincodes[0].block && response.data.pincodes[0].state){
          
        }else{
          this.searchedCityList = []
        }
      }).catch(err =>{
        this.waitingIcon = false
        console.log(err)
      })
    },
    selectSearchedCity(block,state){
        const payload = {
            block: block,
            state: state
          }
          this.waitingIcon = true
          ApiCaller('https://utilities.mall91.com/',`serviceability/pincodes`, "post",payload).then((response) => {
            response.data.pincodes.forEach(list=>{
              if(!this.existPincodeCity.hasOwnProperty(block)) this.$set(this.existPincodeCity,block,[])                  
              if(this.existPincodeCity.hasOwnProperty('xyz')){
                if (!this.existPincodeCity[block].includes(list.pincode) && !this.existPincodeCity['xyz'].includes(list.pincode)){
                  this.existPincodeCity[block].push(list.pincode);
                }
              }else{
                if (!this.existPincodeCity[block].includes(list.pincode)){
                  this.existPincodeCity[block].push(list.pincode);
                }
              }
              if(Object.keys(this.existPincodeCity).length){
                  let tempPincodes = []
                  for(let i in this.existPincodeCity){
                    tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
                  }
                ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${tempPincodes.toString()}`, "get").then((response) => {
                  this.waitingIcon= false
                  this.totalUserCount = response.data.data.userCount
                }).catch( err=>{
                  this.waitingIcon = false
                })
              }

            })
            this.waitingIcon = false
          }).catch(err =>{
            this.waitingIcon = false
            console.log(err)
          })
    },
    unSelectSearchedCity(block,state){
      this.$delete(this.existPincodeCity,block)
      if(Object.keys(this.existPincodeCity).length){
          let tempPincodes = []
          for(let i in this.existPincodeCity){
            tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
          }
          this.shopManageData.pincodes = tempPincodes
        ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${tempPincodes.toString()}`, "get").then((response) => {
          this.waitingIcon= false
          this.totalUserCount = (response.data.data.userCount)
        }).catch( err=>{
          this.waitingIcon = false
        })
      }else{
        this.totalUserCount = 0
      }
    },
    removePincode(_index) {
      if(this.supportedPincodeList.length === 1 ){
        this.totalUserCount = ''
      }
        this.supportedPincodeList.splice(_index, 1);
      if(this.supportedPincodeList.length){
        ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${this.supportedPincodeList.toString()}`, "get").then((response) => {
            this.waitingIcon= false
              this.totalUserCount =(response.data.data.userCount)
          }).catch( err=>{
            this.waitingIcon = false
          })
      }else{
        this.totalUserCount = 0
      }
    },
    removeCityPincode(block,index) {
        this.existPincodeCity[block].splice(index,1)
        if(!this.existPincodeCity[block].length) this.$delete(this.existPincodeCity,block)
        if(Object.keys(this.existPincodeCity).length){
            let tempPincodes = []
            for(let i in this.existPincodeCity){
              tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
            }
            this.shopManageData.pincodes = tempPincodes
          ApiCaller('https://be.payboard.in/PayBoard',`/rest/user/get-user-count-for-pincodes/${tempPincodes.toString()}`, "get").then((response) => {
            this.waitingIcon= false
            this.totalUserCount =(response.data.data.userCount)
          }).catch( err=>{
            this.waitingIcon = false
          })
        }else{
        this.totalUserCount = 0
      }
    },
    getSelectedPincodeOption(_option){
      this.selectedPincodeOption = _option
      this.waitingIcon = true
      if(_option === 'ALL_INDIA'){
        this.totalUserCount = '12 Lakh+'
        this.waitingIcon = false
      }else{
        this.totalUserCount = ''
        this.waitingIcon = false
      }
    },
    changeStatus(value) {
      this.isBankAccount = value;
      this.shopManageData.instantMoneyTransfer = value
    },
    changeDeliveryStatus(action,value) {
        this.homeDeliveryAction = action;
        if(this.homeDeliveryAction === 'DELIVERYOFF'){
            this.shopManageData.homeDeliveryAvailable = false
        }else{
            this.shopManageData.homeDeliveryAvailable = true
        }
        if(this.homeDeliveryAction === "DELIVERYMINORDER"){
          this.shopManageData.minimumOrderAmount = '100'
        }else if(this.homeDeliveryAction === "DELIVERY100MAX"){
          this.shopManageData.deliveryCharges = '10'
        }
        
        
    },
    validateFields(){
       if(this.homeDeliveryAction === 'DELIVERYMINORDER'){
            if(this.shopManageData.minimumOrderAmount === null){
             this.toasterData = {
                msg: `Please enter maximum order amount`,
                color: "#e51c24",
                iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }else{
            if(parseFloat(this.shopManageData.minimumOrderAmount) >= '0' && parseFloat(this.shopManageData.minimumOrderAmount) <= '1000'){               
                if(this.shopManageData.codEnable || this.shopManageData.onlineEnable || this.whatsAppEnable){
                   if(this.whatsAppEnable){
                    if(!this.shopManageData.whatsAppNumber){
                      this.toasterData = {
                        msg: 'Please Enter WhatsApp Number',
                        color: "#e51c24",
                        iconName: "close",
                      };
                      this.isValidDetail = true;
                      return false
                    }else{
                      if (
                        !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(this.shopManageData.whatsAppNumber)
                      ) {
                        this.toasterData = {
                          msg: this.$t("enterValidMobileNumber"),
                          color: "#e51c24",
                          iconName: "close",
                        };
                        this.isValidDetail = true;
                        return false;
                      }
                    }
                  }
                    console.log(this.shopManageData)
                  this.upadateDeliveryForm()
                  }else{
                    this.toasterData = {
                        msg: 'Please select payment option to update shop setting',
                        color: "#e51c24",
                        iconName: "close",
                      };
                      this.isValidDetail = true;
                      return false;
                  }  
                }else{
                    this.toasterData = {
                    msg: `Please enter maximum order amount ₹ 1000 `,
                    color: "#e51c24",
                    iconName: "close",
                };
                this.isValidDetail = true;
                return false;
            }
          }
        }
          if(this.homeDeliveryAction === 'DELIVERY100MAX'){
              if(this.shopManageData.deliveryCharges === null){
             this.toasterData = {
                msg: `Please enter delivery charges`,
                color: "#e51c24",
                iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }else{
            if(parseFloat(this.shopManageData.deliveryCharges) >= this.shopManageData.minimumDeliveryCharges && parseFloat(this.shopManageData.deliveryCharges) <= this.shopManageData.maximumDeliveryCharges){               
                if(this.shopManageData.codEnable || this.shopManageData.onlineEnable || this.whatsAppEnable){
                   if(this.whatsAppEnable){
                    if(!this.shopManageData.whatsAppNumber){
                      this.toasterData = {
                        msg: 'Please Enter WhatsApp Number',
                        color: "#e51c24",
                        iconName: "close",
                      };
                      this.isValidDetail = true;
                      return false
                    }else{
                      if (
                        !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(this.shopManageData.whatsAppNumber)
                      ) {
                        this.toasterData = {
                          msg: this.$t("enterValidMobileNumber"),
                          color: "#e51c24",
                          iconName: "close",
                        };
                        this.isValidDetail = true;
                        return false;
                      }
                    }
                  }
                    console.log(this.shopManageData)
                  this.upadateDeliveryForm()
                  }else{
                    this.toasterData = {
                        msg: 'Please select payment option to update shop setting',
                        color: "#e51c24",
                        iconName: "close",
                      };
                      this.isValidDetail = true;
                      return false;
                  }  
                }else{
                    this.toasterData = {
                    msg: `Please enter amount between ₹${this.shopManageData.minimumDeliveryCharges} and ₹${this.shopManageData.maximumDeliveryCharges}`,
                    color: "#e51c24",
                    iconName: "close",
                };
                this.isValidDetail = true;
                return false;
                }
            }
          }
          if(this.shopManageData.codEnable || this.shopManageData.onlineEnable || this.whatsAppEnable){
            if(this.whatsAppEnable){
              if(!this.shopManageData.whatsAppNumber){
                this.toasterData = {
                  msg: 'Please Enter WhatsApp Number',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isValidDetail = true;
                return
              }else{
                      if (
                        !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(this.shopManageData.whatsAppNumber)
                      ) {
                        this.toasterData = {
                          msg: this.$t("enterValidMobileNumber"),
                          color: "#e51c24",
                          iconName: "close",
                        };
                        this.isValidDetail = true;
                        return false;
                      }
                    }
            }
            console.log(this.shopManageData)
            this.upadateDeliveryForm()
          }else{
            this.toasterData = {
              msg: 'Please select payment option to update shop setting',
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
    },
    upadateDeliveryForm() {
      this.loading = true;
      if(this.homeDeliveryAction === "FREEDELIVERY"){
          this.shopManageData.minimumOrderAmount = null;
          this.shopManageData.deliveryCharges = null
      }else if(this.homeDeliveryAction === "DELIVERYMINORDER"){
          this.shopManageData.deliveryCharges = null
      }else if(this.homeDeliveryAction === "DELIVERY100MAX"){
          this.shopManageData.minimumOrderAmount = null
      }
      let obj
      if(this.$route.query.CLOUDSHOP){
         obj = {
            instantMoneyTransfer: this.isBankAccount,
            homeDeliveryAvailable: this.shopManageData.homeDeliveryAvailable,
            minimumOrderAmount: null,
            deliveryCharges: null,
            discountPercentage: this.shopManageData.discountPercentage,
            codEnable : this.shopManageData.codEnable,
            onlineEnable : this.shopManageData.onlineEnable
        }
      }else{
        obj = {
            instantMoneyTransfer: this.isBankAccount,
            homeDeliveryAvailable: this.shopManageData.homeDeliveryAvailable,
            minimumOrderAmount: this.shopManageData.minimumOrderAmount,
            deliveryCharges: this.shopManageData.deliveryCharges,
            discountPercentage: this.shopManageData.discountPercentage,
            codEnable : this.shopManageData.codEnable,
            onlineEnable : this.shopManageData.onlineEnable
        }
      }
      
      if(this.selectedPincodeOption ==='ALL_INDIA'){
             obj.pincodes = []
             obj.isGlobalShop = true
             
            }else if(this.selectedPincodeOption ==='ADD_PINCODE'){
            if(this.supportedPincodeList.length){
               obj.pincodes = this.supportedPincodeList
            }else{
                this.toasterData = {
                  msg: 'दुकान कहाँ दिखाना चाहते हैं ?',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isValidDetail = true;
                this.loading = false;
                return false
            }
            }else if(this.selectedPincodeOption ==='CITY_PINCODE'){
            if(Object.keys(this.existPincodeCity).length){
                let tempPincodes = []
                for(let i in this.existPincodeCity){
                    tempPincodes = [...tempPincodes, ...this.existPincodeCity[i]]
                }
               obj.pincodes = tempPincodes
            }else{
                this.toasterData = {
                  msg: 'दुकान कहाँ दिखाना चाहते हैं ?',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.loading = false;
                this.isValidDetail = true;
                return false
            }
          }
      if(this.whatsAppEnable){
        obj.whatsAppNumber = this.shopManageData.whatsAppNumber 
      }else{
        obj.whatsAppNumber = null
      }
      ApiCaller(
        constant.SELLER_DETAIL_URL,
        "update-seller-shop-setting?shopid=" + this.$route.query.shopid,
        "post",
        obj
      )
        .then((data) => {
          this.supportedPincodeList = []
             this.existPincodeCity = {}
             this.selectedCityOption = ''
          this.getShopManageData()
          this.toasterData = {
                msg: `Settings updated successfully`,
                color: "green",
                iconName: "close",
            }
            this.isValidDetail = true;
        })
        .catch((err) => {
          this.loading = false;
          if(err.response.data.errorCodes[0] === 'INVALID_MINIMUM_ORDER_AMOUNT'){
              this.toasterData = {
                msg: `Please enter valid minimum order amount`,
                color: "#e51c24",
                iconName: "close",
            }
            this.isValidDetail = true;
          }else if(err.response.data.errorCodes[0] === 'INVALID_DELIVERY_CHARGES_RANGE'){
              this.toasterData = {
                msg: `Please enter amount between ₹${this.shopManageData.minimumDeliveryCharges} and ₹${this.shopManageData.maximumDeliveryCharges}`,
                color: "#e51c24",
                iconName: "close",
            }
            this.isValidDetail = true;
          }
          console.log(err);
        });
    },
    getShopManageData(){
        this.loading = true
        ApiCaller(
        constant.SELLER_DETAIL_URL,
        "get-seller-shop-setting?shopid=" + this.$route.query.shopid,
        "get"
      )
        .then((data) => {
            this.loading = false
          this.shopManageData = data.data
          this.isBankAccount = data.data.instantMoneyTransfer
          if(data.data.homeDeliveryAvailable && data.data.minimumOrderAmount){
              this.homeDeliveryAction = "DELIVERYMINORDER"
          }else if(data.data.homeDeliveryAvailable && data.data.deliveryCharges){
              this.homeDeliveryAction = "DELIVERY100MAX"
          }else if(data.data.homeDeliveryAvailable){
              this.homeDeliveryAction = "FREEDELIVERY"
          }else{
              this.homeDeliveryAction = "DELIVERYOFF"
          }
          if(data.data.pincodes && data.data.pincodes.length > 0 && !data.data.isGlobalShop){
            this.selectedPincodeOption = 'ADD_PINCODE'
            this.shopManageData.pincodes = data.data.pincodes
            this.supportedPincodeList = data.data.pincodes
            this.existPincodeCity['xyz'] = data.data.pincodes
          }else{
            this.selectedPincodeOption = 'ALL_INDIA'
          }
          if(!this.shopManageData.whatsAppNumber){
            this.shopManageData.whatsAppNumber = this.$store.state.userInfo.phone
          }else if(this.shopManageData.whatsAppNumber){
              this.shopManageData.whatsAppNumber = this.shopManageData.whatsAppNumber
              this.whatsAppEnable = true
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getShopQrDetail() {
      if (this.$cookie.get("X-Auth-Id") != null) {
        this.loading = true
        let payloadObject;
          if(this.$route.query.shopid){
            payloadObject = `get-seller-shop-qr?shopid=${this.$route.query.shopid}`
          }else{
            payloadObject = 'get-seller-shop-qr'
          }
        ApiCaller(constant.SELLER_DETAIL_URL, payloadObject, "get")
          .then((data) => {
            this.shopQrDetail = data.data;
            this.loading = false
          })
          .catch((err) => {
            this.loading = false;
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getShopQrDetail();
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              console.log(err)
            }
          });
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
  },
  mounted() {
    if(this.$route.query.shopid){
      this.getShopManageData();
    }
    
    // this.getShopVerificationDocument();
    this.getShopQrDetail();
  },
};
</script>
<style lang="scss" scoped>
.radio-option{
        display: flex;
        margin-bottom: 8px;
        font-size: 0.875em;
        .text{            
            margin-left: 8px;
        }
        &.active{
            .select-radio{
                &::after{
                    content: '';
                    width: 13px;
                    height: 13px;
                    position: absolute;
                    background: green;
                    border-radius: 50%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50% , -50%);
                }
            }
        .text{
            color: green;
            font-weight: 600;
        }
        }
    }
    .select-radio{
        content: '';
        width: 20px;
        height: 20px;
        display: inline-block;
        border: 1px solid green;
        border-radius: 50%;
        position: relative;
    }
    .search_bar{
      border: 1px solid #ccc;
    padding: 8px;
    border-radius: 25px;
    margin-top: 8px;
    i{
          font-size: 20px;
    padding-right: 8px;
        color: #838485;
    }
    .input-style{
  width: 100%;
    margin-top: 8px;
    border-radius: 25px;
    border: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
        text-transform: capitalize;


}
}

.city_list{
  // position: absolute;
  //   top: 40px;
    background: #fff;
    z-index: 9;
    width: 100%;
    left: 0;
    box-shadow: 0 0px 30px 0px rgb(0 0 0 / 25%);
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 5px;
    .city-row{
      width: 100%;
    justify-content: space-between;
    display: flex;
    align-items: center;
    }
    .city_name{
      width: 60%;
      &.active{
        color: green;
        font-weight: 600;
      }
    }
    h5{
    margin-bottom: 8px;
    }
    ul{
      border: 1px solid #ccc;
      max-height: 120px;
      overflow: scroll;
      border-radius: 5px;
      padding: 8px;
      // padding-bottom: 0;
    li{
        padding: 4px 0;
        display:flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ccc;
        font-size: 0.875em;
        font-weight: 500;
        color: #505050;
          &:last-child{
            border-bottom: none;
          }
    }
    }
}
.chiplisting li {
    width: auto;
    background: #fff;
    border-radius: 25px;
    border: 1px solid #dddddd;
    padding: 4px 28px 4px 8px;
    margin: 4px 2px 0 0;
    display: inline-block;
    position: relative;
    line-height: 0;
    .text-label {
    font-size: 0.75em;
    color: #505050;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;
    margin-bottom: 0px;
}
.remove-pin {
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    position: absolute;
    right: 4px;
    top: 3px;
}
}
.field-row .input-style {
    width: 100%;
    height: auto;
    padding: 8px;
    border: 1px solid #D9D9D9;
    color: #000;
    font-size: 0.875em;
    border-radius: 6px;
    line-height: 1.5;
}

.verified-detail{
  background: #fff;
  border-bottom: 1px solid #ccc;
  padding-top: 15px;
  height:auto;
.form-status{
  padding: 8px;
  text-align: center;
  .status-text{
    color: #fff;
    font-size: 0.938em;
    padding: 4px 8px;
    border-radius: 6px;
    // display: block;
    margin-bottom: 4px;
    
  }
  .info-text{
    color: #727272;
    font-size: 0.875em;
        margin-top: 8px;
  }
}
.reject-reason{
  background:#F9EEED;
  border: 1px solid #B63529;
  border-radius: 4px;
  margin: 4px 15px;
  font-size: 0.75em;
  padding: 8px;
  color: #505050;
  strong{
      color: #C81000;
    }
}
.verified-reason{
  background:#13880829;
  border: 1px solid #138808;
  border-radius: 4px;
  margin: 4px 15px;
  font-size: 0.75em;
  padding: 8px;
  color: #505050;
  strong{
      color: #C81000;
    }
}
.doc-list{
      width: 60%;
      margin-top: 15px;
  li{
    width: 85px;
    height: 85px;
    text-align: center;
    margin-right: 8px;
    background: #F4F6F8;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid #ccc;
    video,img{
      max-width: 100%;
      max-height: 100%;
    }
    .default-icon{
      position: absolute;
    background: #ffffffde;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    transform: translate(-50% , -50%);
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    }
    
  }
  
}
.view-doc{
  margin-top: 15px;
      height: 85px;
      width: 85px;
      display: block;
      padding: 8px;
      font-size: 0.875em;
      color: #0083D1;
      text-align: center;
      display: flex;
      align-items: center;
      background: #F4F6F8;
      border-radius: 4px;
  }
}

.shop-management {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding-top: 63px;
  padding-bottom: 60px;
  .transfer-bank-account {
    padding: 20px;
    border-bottom: 1px solid #9e9e9e80;
    color: #505050;
    &.homedelivery {
      border-bottom: 0;
          padding-bottom: 60px;
    }
    h3 {
      color: #505050;
      font-size: 1.125em;
      font-weight: 500;
    }
    .list-item {
      padding-top: 15px;
      li {
        padding: 8px 0;
        padding-left: 30px;
        display: flex;
        align-items: center;
        position: relative;
        .flx{
                width: 100%;
        }
        .custom-radio {
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 1px solid #505050;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          &.active {
            border: 1px solid #ff9934;
            &::before {
              width: 14px;
              height: 14px;
              content: "";
              background: #ff9934;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
        p {
          font-size: 0.875em;
          line-height: 1.65;
          display: block;
          &.padding-top {
            padding-top: 8px;
          }
          &.width70 {
            width: 70%;
          }
          span {
            background: #dddddd;
            padding: 3px 5px;
            border-radius: 2px;
            margin-left: 5px;
          }
        }
        input {
          width: 25%;
          border: 1px solid #dddddd;
          text-align: center;
              height: 35px;
              &::placeholder{
                  font-weight: 600;
              }
        }
      }
    }
  }
}
.full-btn{
  position: fixed;
    bottom: 0px;
    width: 100%;
    background: #fff;
    padding: 15px 0;
}
.submit-button{
    // position: fixed;
    // bottom: 15px;
    width: calc(100% - 80px);
    margin: 0 auto;
    left: 40px;
    text-align: center;
    padding: 8px;
    background: #FE9935;
    color: #fff;
    border-radius: 4px;
}
</style>